module.exports = __webpack_public_path__ + "static/img/89053C_2_3_C_20200123_fit.da4d837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/89053C_2_3_C_20200123_fit.png
// module id = SUxc
// module chunks = 0